import { Col, Flex, Form, Row, message } from "antd";
import React from "react";
import { CustomButton, CustomInput } from "../../../components";
import { sendContactSalesEmail } from "../../../api's/sendcontactemail";

const ContactSalesTeam = ({closeModal }) => {
  const [form] = Form.useForm();
  const onFinish = async (values) => {

    const { success, message: resultMessage } = await sendContactSalesEmail({
      recipient: values.email,
      name: values.name,
      companyName: values.companyName,
      message: values.message || "No additional message provided.",
      earlysignup:false
    });

    if (success) {
      message.success(resultMessage);
      form.resetFields();
      closeModal();
    } else {
      message.error(resultMessage);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error('Please fill out all required fields.');
  };

  return (
    <div>
      <Form
      form={form}
        name="contactSalesForm"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Row gutter={[12, 24]} style={{margin:"0px"}}>
          <Col xs={24} sm={24} lg={12}>
            <Form.Item
              className="custom-input"
              label="Your Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please input your name",
                },
              ]}
            >
              <CustomInput
                placeholder="First and last"
                height="36px"
                border="0px"
                bgColor="#f3f3f3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} lg={12}>
            <Form.Item
              label="Your email"
              name="email"
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: "Please input a valid email",
                },
              ]}
            >
              <CustomInput
                placeholder="name@example.com"
                height="36px"
                border="0px"
                bgColor="#f3f3f3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Company name"
              name="companyName"
              rules={[
                {
                  required: true,
                  message: "Please input your company name",
                },
              ]}
            >
              <CustomInput
                placeholder="Your company’s name"
                height="36px"
                border="0px"
                bgColor="#f3f3f3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="How are you looking to use ZoomLogi?"
              name="message"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <CustomInput
                placeholder="Describe how you plan to use ZoomLogi"
                height="100px"
                border="0px"
                bgColor="#f3f3f3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          </Col>
        </Row>
        <Flex justify="end">
              
            <div style={{marginTop: '10px',marginRight:"6px"}}>
            <CustomButton
              text={"Submit"}
              bgColor="black"
              color="white"
              height="48px"
              width="100px"
              fontSize="16px"
              fontWeight="500"
              boxShadow="none"
              borderRadius="8px"
              htmlType='submit'
              margin-top="16px"
            />
            </div>
              {/* <button type="submit" style={{ padding: '8px 16px', borderRadius: '8px' }}>
                Submit
              </button> */}
            </Flex>
      </Form>
    </div>
  );
};

export default ContactSalesTeam;